import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// ResizeObserver "loop" errors are benign per the WHATWG spec but surface as
// uncaught runtime errors — swallow only those, let everything else through.
const isBenignResizeObserverError = (msg) =>
  typeof msg === "string" && msg.includes("ResizeObserver loop");

window.addEventListener("error", (e) => {
  if (isBenignResizeObserverError(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (isBenignResizeObserverError(e.reason && e.reason.message)) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
